var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.checkBoxList.length
    ? _c(
        "div",
        {
          staticClass:
            "filter-item filter-item--checkbox filter-item--checklist"
        },
        [
          _c("h2", {
            staticClass: "filter-item__heading",
            domProps: { textContent: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-item__checklist" },
            _vm._l(_vm.checkBoxList, function(checkbox, checkboxKey) {
              return _c("checkbox", {
                key: checkbox.keyword.code,
                attrs: { name: checkbox.name, value: checkbox.active },
                on: {
                  checked: function(checked) {
                    return _vm.selectKeyword(checked, checkboxKey)
                  }
                }
              })
            })
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00b0bc52", { render: render, staticRenderFns: staticRenderFns })
  }
}